import { render, staticRenderFns } from "./name.vue?vue&type=template&id=45dd472a&scoped=true&"
import script from "./name.vue?vue&type=script&lang=js&"
export * from "./name.vue?vue&type=script&lang=js&"
import style0 from "./name.vue?vue&type=style&index=0&id=45dd472a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dd472a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45dd472a')) {
      api.createRecord('45dd472a', component.options)
    } else {
      api.reload('45dd472a', component.options)
    }
    module.hot.accept("./name.vue?vue&type=template&id=45dd472a&scoped=true&", function () {
      api.rerender('45dd472a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/illicit-barcode/campaign/validation/name.vue"
export default component.exports